package com.exura.features.plandefinition.usecase

import com.exura.features.firebase.domain.model.versioning.Version
import com.exura.features.plandefinition.domain.model.metadata.PlanDefinitionMetadata
import com.exura.features.plandefinition.domain.model.plan.BasePlan
import com.exura.features.plandefinition.domain.repository.ProviderVersionedTreatmentRepository
import kotlinx.coroutines.flow.Flow

class ListTreatmentPlansUseCase(
    private val repository: ProviderVersionedTreatmentRepository
) {
    suspend operator fun invoke(): Result<Flow<List<Version<BasePlan, PlanDefinitionMetadata>>>>
    = runCatching { repository.list() }
}
